"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var bitcoin = _interopRequireWildcard(require("@oipwg/bitcoinjs-lib"));

var _bitcoinjsMessage = _interopRequireDefault(require("@oipwg/bitcoinjs-message"));

var _util = require("./util");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ECPair = bitcoin.ECPair;
/**
 * [@oipwg/bitcoinjs-lib ECPair](https://github.com/bitcoinjs/@oipwg/bitcoinjs-lib/blob/master/src/ecpair.js#L16)
 * @typedef {Object} ECPair
 */

/**
 * Contains information about an Unspent Transaction Output
 * @typedef {Object} utxo
 * @property {string} address - Base58 Public Address
 * @property {string} txid - The Transaction ID
 * @property {number} vout - The Index of this specific Output in its parent Transaction
 * @property {string} scriptPubKey - The Script Public Key Hash
 * @property {number} amount - Amount (in whole Coin) of this Output
 * @property {number} satoshis - Amount in Satoshis of this Output
 * @property {number} height - The Blockheight the Parent Transaction was confirmed in
 * @property {number} confirmations - The total number of Confirmations the Parent Transaction has received
 * @example
 * {
 *   address: 'F8P6nUvDfcHikqdUnoQaGPBVxoMcUSpGDp',
 *   txid: '7687e361f00998f96b29938bf5b7d9003a15ec182c13b6ddbd5adc0f993cbf9c',
 *   vout: 1,
 *   scriptPubKey: '76a9141bfcff1731caf3a16225d3e78735ddc229e4fc6c88ac',
 *   amount: 0.001,
 *   satoshis: 100000,
 *   height: 2784696,
 *   confirmations: 6828
 * }
 */

/**
 * Contains information about an Unspent Transaction Output
 * @typedef {Object} AddressState
 * @property {string} addrStr - Base58 Public Address
 * @property {number} balanceSat - Balance of the Address in Satoshis
 * @property {number} totalReceivedSat - Total Received to the Address in Satoshis
 * @property {number} unconfirmedBalanceSat - Unconfirmed Balance of the Address in Satoshis
 * @property {Array.<string>} transactions - Array of `txids` that have been confirmed on the Network
 * @property {Array.<string>} spentTransactions - Array of `txids` that have been spent, but not yet confirmed on the Network
 * @property {number} lastUpdated - Timestamp of when the Address was last updated/synced with the Explorer
 * @example
 * {
 *   addrStr: 'F8P6nUvDfcHikqdUnoQaGPBVxoMcUSpGDp',
 *   balanceSat: 0,
 *   totalReceivedSat: 0,
 *   unconfirmedBalanceSat: 0,
 *   transactions: [],
 *   spentTransactions: [],
 *   lastUpdated: 0
 * }
 */

/**
 * Manages information about a specific Address
 */

var Address = /*#__PURE__*/function () {
  /**
   * Create a new Address based on either a bip32 node, WIF Private Key, or Public Address
   * ##### Examples
   * Create Address from bip32
   * ```
   * import * as bip32 from 'bip32';
   * import { Address, Networks } from '@oipwg/hdmw';
   *
   * let node = bip32.fromBase58("Fprv52CvMcVNkt3jU7MjybjTNie1Bqm7T66KBueSVFW74hXH43sXMAUdmk73TENACSHhHbwm7ZnHiaW3DxtkwhsbtpNjsh4EpnFVjZVJS7oxNqw", Networks.flo.network)
   * let address = new Address(node, Networks.flo);
   * ```
   * Create Address from WIF
   * ```
   * import { Address, Networks } from '@oipwg/hdmw';
   *
   * let address = new Address("RAtKUeXYMEHEFkhbJuXGMEQZsqgHosnP2BLVaLWMRswWrcCNbZk5", Networks.flo);
   * ```
   * Create Address from Base58 Public Address
   * ```
   * import { Address, Networks } from '@oipwg/hdmw';
   *
   * let address = new Address("F8P6nUvDfcHikqdUnoQaGPBVxoMcUSpGDp", Networks.flo);
   * ```
   * @param  {bip32|string} address - The Public Address, Private Key (WIF), or bip32 Node that the Address is for.
   * @param  {CoinInfo} coin - CoinInfo for the specific Address
   * @param  {boolean|AddressState} [discover=false] - Either a `boolean` value for if the Address should auto-discover, or an AddressState object to load the Internal state from.
   * @return {Address}
   */
  function Address(address, coin, discover) {
    _classCallCheck(this, Address);

    if (address.network !== undefined) {
      this.fromBIP32 = true;

      if (address.address) {
        this.address = address.address;
      } else if (address.index !== undefined && address.depth !== undefined) {
        this.address = address;
      } // Make sure that the networks match and throw an error if they don't


      if (address.network.pubKeyHash !== coin.network.pubKeyHash) {
        throw new Error('Address Network and Coin Network DO NOT MATCH!!!!!');
      }
    } else {
      if ((0, _util.isValidPublicAddress)(address, coin.network)) {
        this.fromBIP32 = false;
        this.pubAddress = address;
      } else if ((0, _util.isValidWIF)(address, coin.network)) {
        this.fromBIP32 = true;
        this.address = ECPair.fromWIF(address, coin.network);
      }
    }

    this.coin = coin || {
      satPerCoin: 1e8
    }; // Setup internal variables

    this.transactions = [];
    this.balanceSat = 0;
    this.totalReceivedSat = 0;
    this.totalSentSat = 0;
    this.unconfirmedBalanceSat = 0;
    this.lastUpdated = 0;
    this.spentTransactions = [];

    if (discover === true) {
      // Update the state from the explorer
      this.updateState();
    } else if (discover) {
      // Load from serialized JSON
      this.deserialize(discover);
    }
  }
  /**
   * Get the Base58 sharable Public Address
   * @example
   * import { Address, Networks } from '@oipwg/hdmw';
   *
   * let address = new Address("RAtKUeXYMEHEFkhbJuXGMEQZsqgHosnP2BLVaLWMRswWrcCNbZk5", Networks.flo);
   * let pubAddr = address.getPublicAddress();
   * // pubAddr = F8P6nUvDfcHikqdUnoQaGPBVxoMcUSpGDp
   * @return {string}
   */


  _createClass(Address, [{
    key: "getPublicAddress",
    value: function getPublicAddress() {
      var publicKey;

      if (this.fromBIP32 && this.address) {
        publicKey = this.address.publicKey;

        if (!publicKey && this.address.getPublicKeyBuffer) {
          publicKey = this.address.getPublicKeyBuffer();
        }
      }

      return this.fromBIP32 ? (0, _util.toBase58)(publicKey, this.coin.network.pubKeyHash) : this.pubAddress;
    }
    /**
     * Get the Base58 sharable Private Address (WIF)
     * @example
     * import * as bip32 from 'bip32';
     * import { Address, Networks } from '@oipwg/hdmw';
     *
     * let node = bip32.fromBase58("Fprv52CvMcVNkt3jU7MjybjTNie1Bqm7T66KBueSVFW74hXH43sXMAUdmk73TENACSHhHbwm7ZnHiaW3DxtkwhsbtpNjsh4EpnFVjZVJS7oxNqw", Networks.flo.network)
     * let address = new Address(node, Networks.flo);
     * let wif = address.getPrivateAddress();
     * // wif = RAtKUeXYMEHEFkhbJuXGMEQZsqgHosnP2BLVaLWMRswWrcCNbZk5
     * @return {string}
     */

  }, {
    key: "getPrivateAddress",
    value: function getPrivateAddress() {
      return this.address ? this.address.toWIF() : undefined;
    }
    /**
     * Get the internal ECPair. This is used when you need to Sign Transactions, or to access the raw public/private Buffers.
     * Please note that if you create the Address from a Public Key, you will not get back an ECPair, since we need access
     * to the Private Key in order to create/access the ECPair. When Address is created using a bip32 node or a Private Key (WIF)
     * the ECPair will exist.
     * @example
     * import * as bip32 from 'bip32';
     * import { Address, Networks } from '@oipwg/hdmw';
     *
     * let node = bip32.fromBase58("Fprv52CvMcVNkt3jU7MjybjTNie1Bqm7T66KBueSVFW74hXH43sXMAUdmk73TENACSHhHbwm7ZnHiaW3DxtkwhsbtpNjsh4EpnFVjZVJS7oxNqw", Networks.flo.network)
     * let address = new Address(node, Networks.flo);
     * let ecpair = address.getECPair();
     * @return {ECPair}
     */

  }, {
    key: "getECPair",
    value: function getECPair() {
      return this.address;
    }
    /**
     * Get the signature of a specific message that can be verified by others
     * @param  {String} message - The message you wish to get the signature for
     * @return {String} Returns the base64 string of the created Signature
     */

  }, {
    key: "signMessage",
    value: function signMessage(message) {
      if (!message || typeof message !== 'string') {
        throw new Error('Message must be defined and a String!');
      }

      var privatekeyEcpair = this.getECPair();

      if (!privatekeyEcpair) {
        throw new Error('No Private Key available! Unable to sign message!');
      }

      var privateKeyBuffer = privatekeyEcpair.privateKey;
      var compressed = privatekeyEcpair.compressed !== undefined ? privatekeyEcpair.compressed : true;
      var messagePrefix = this.coin.network.messagePrefix;
      var signatureBuffer;

      try {
        signatureBuffer = _bitcoinjsMessage.default.sign(message, privateKeyBuffer, compressed, messagePrefix);
      } catch (e) {
        throw new Error('Unable to create signature! \n' + e);
      }

      return signatureBuffer.toString('base64');
    }
    /**
     * Verify the signature of a given message
     * @param  {String} message   - The message you want to verify
     * @param  {String} signature - The signature of the message
     * @return {Boolean} Returns either `true` or `false` depending on if the signature and message match
     */

  }, {
    key: "verifySignature",
    value: function verifySignature(message, signature) {
      var valid;

      try {
        valid = _bitcoinjsMessage.default.verify(message, this.getPublicAddress(), signature, this.coin.network.messagePrefix);
      } catch (e) {
        throw new Error('Unable to verify signature! \n' + e);
      }

      return valid;
    }
    /**
     * Get the latest State for this address from the Blockchain Explorer
     * @example
     * import { Address, Networks } from '@oipwg/hdmw';
     *
     * let address = new Address("F8P6nUvDfcHikqdUnoQaGPBVxoMcUSpGDp", Networks.flo);
     * address.updateState().then((addr) => {
     *   console.log(addr.getTotalReceived())
     * })
     * @return {Promise<Address>} Returns a Promise that will resolve to the Address
     */

  }, {
    key: "updateState",
    value: function () {
      var _updateState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var state;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.coin.explorer.getAddress(this.getPublicAddress());

              case 3:
                state = _context.sent;
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                throw new Error('Error Updating Address State for: ' + this.getPublicAddress() + '\n' + _context.t0);

              case 9:
                return _context.abrupt("return", this.deserialize(state));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function updateState() {
        return _updateState.apply(this, arguments);
      }

      return updateState;
    }()
    /**
     * Hydrate an Address from the serialized JSON, or update the state
     * @param  {AddressState} state
     * @example
     * import { Address, Networks } from '@oipwg/hdmw';
     *
     * let address = new Address("F8P6nUvDfcHikqdUnoQaGPBVxoMcUSpGDp", Networks.flo, false);
     *
     * address.deserialize({
     *   addrStr: 'F8P6nUvDfcHikqdUnoQaGPBVxoMcUSpGDp',
     *   balanceSat: 123,
     *   totalReceivedSat: 234,
     *   unconfirmedBalanceSat: 345,
     *   transactions: ['abcde'],
     *   spentTransactions: ['bcdef'],
     *   lastUpdated: 456
     * })
     *
     * let balance = address.getBalance()
     * // balance = 0.00000123
     * @return {Address}
     */

  }, {
    key: "deserialize",
    value: function deserialize(state) {
      if (!state) {
        return;
      } // If the state doesn't match for this address, ignore it.


      if (state.addrStr && state.addrStr !== this.getPublicAddress()) {
        return;
      }

      if (!isNaN(state.balanceSat)) {
        this.balanceSat = state.balanceSat;
      }

      if (!isNaN(state.totalReceivedSat)) {
        this.totalReceivedSat = state.totalReceivedSat;
      }

      if (!isNaN(state.totalSentSat)) {
        this.totalSentSat = state.totalSentSat;
      }

      if (!isNaN(state.unconfirmedBalanceSat)) {
        this.unconfirmedBalanceSat = state.unconfirmedBalanceSat;
      }

      if (Array.isArray(state.transactions)) {
        this.transactions = state.transactions;
      }

      if (Array.isArray(state.spentTransactions)) {
        var _iterator = _createForOfIteratorHelper(state.spentTransactions),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var tx = _step.value;
            this.spentTransactions.push(tx);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      if (!isNaN(state.lastUpdated)) {
        this.lastUpdated = state.lastUpdated;
      } else {
        this.lastUpdated = Date.now();
      }

      return this;
    }
    /**
     * Get a serialized version of the Address (dried out JSON)
     * @example
     * import { Address, Networks } from '@oipwg/hdmw';
     *
     * let address = new Address("F8P6nUvDfcHikqdUnoQaGPBVxoMcUSpGDp", Networks.flo, false);
     *
     * let addressState = address.serialize()
     * // addressState = {
     * //   addrStr: 'F8P6nUvDfcHikqdUnoQaGPBVxoMcUSpGDp',
     * //   balanceSat: 0,
     * //   totalReceivedSat: 0,
     * //   unconfirmedBalanceSat: 0,
     * //   transactions: [],
     * //   spentTransactions: [],
     * //   lastUpdated: 0
     * // }
     * @return {AddressState}
     */

  }, {
    key: "serialize",
    value: function serialize() {
      return {
        addrStr: this.getPublicAddress(),
        wif: this.getPrivateAddress(),
        balanceSat: this.balanceSat,
        totalReceivedSat: this.totalReceivedSat,
        unconfirmedBalanceSat: this.unconfirmedBalanceSat,
        transactions: this.transactions,
        spentTransactions: this.spentTransactions,
        lastUpdated: this.lastUpdated
      };
    }
    /**
     * Get the Balance (in whole coins) for the Address
     * @example
     * import { Address, Networks } from '@oipwg/hdmw';
     *
     * let address = new Address("F8P6nUvDfcHikqdUnoQaGPBVxoMcUSpGDp", Networks.flo, false);
     * let balance = address.getBalance();
     * // balance = 0
     * @return {number}
     */

  }, {
    key: "getBalance",
    value: function getBalance() {
      return this.balanceSat / this.coin.satPerCoin;
    }
    /**
     * Get the Total Received balance (in whole coins) for the Address
     * @example
     * import { Address, Networks } from '@oipwg/hdmw';
     *
     * let address = new Address("F8P6nUvDfcHikqdUnoQaGPBVxoMcUSpGDp", Networks.flo, false);
     * let totReceived = address.getTotalReceived();
     * // totReceived = 0
     * @return {number}
     */

  }, {
    key: "getTotalReceived",
    value: function getTotalReceived() {
      return this.totalReceivedSat / this.coin.satPerCoin;
    }
    /**
     * Get the Total Sent balance (in whole coins) for the Address
     * @example
     * import { Address, Networks } from '@oipwg/hdmw';
     *
     * let address = new Address("F8P6nUvDfcHikqdUnoQaGPBVxoMcUSpGDp", Networks.flo, false);
     * let totSent = address.getTotalSent();
     * // totSent = 0
     * @return {number}
     */

  }, {
    key: "getTotalSent",
    value: function getTotalSent() {
      return this.totalSentSat / this.coin.satPerCoin;
    }
    /**
     * Get the Unconfirmed Balance (in whole coins) for the Address
     * @example
     * import { Address, Networks } from '@oipwg/hdmw';
     *
     * let address = new Address("F8P6nUvDfcHikqdUnoQaGPBVxoMcUSpGDp", Networks.flo, false);
     * let uBal = address.getUnconfirmedBalance();
     * // uBal = 0
     * @return {number}
     */

  }, {
    key: "getUnconfirmedBalance",
    value: function getUnconfirmedBalance() {
      return this.unconfirmedBalanceSat / this.coin.satPerCoin;
    }
    /**
     * Get the unspent transaction outputs for the Address
     * @example
     * import { Address, Networks } from '@oipwg/hdmw';
     *
     * let address = new Address("F8P6nUvDfcHikqdUnoQaGPBVxoMcUSpGDp", Networks.flo, false);
     * address.getUnspent().then((utxos) => {
     *   console.log(utxos);
     * })
     * @return {Promise<Array.<utxo>>} Returns a Promise that resolves to an Array of utxos.
     */

  }, {
    key: "getUnspent",
    value: function getUnspent() {
      var _this = this;

      return this.coin.explorer.getAddressUtxo(this.getPublicAddress()).then(function (utxos) {
        return _this.removeSpent(utxos);
      });
    }
    /**
     * Remove the already spent outputs from the array we are given.
     * @param  {Array.<utxo>} unspentTransactions - An Array containing utxos to sort through
     * @example
     * import { Address, Networks } from '@oipwg/hdmw';
     *
     * let address = new Address("F8P6nUvDfcHikqdUnoQaGPBVxoMcUSpGDp", Networks.flo, false);
     * address.getUnspent().then((utxos) => {
     *   let unspentUtxos = address.removeSpent(utxos)
     *   console.log(unspentUtxos)
     * })
     * @return {Array.<utxo>}
     */

  }, {
    key: "removeSpent",
    value: function removeSpent(unspentTransactions) {
      // If we are not defined, or we are not an array, just return
      if (!unspentTransactions || !Array.isArray(unspentTransactions)) {
        return;
      }

      var unspent = [];

      var _iterator2 = _createForOfIteratorHelper(unspentTransactions),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var tx = _step2.value;
          var spent = false;

          var _iterator3 = _createForOfIteratorHelper(this.spentTransactions),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var txid = _step3.value;

              if (txid === tx.txid) {
                spent = true;
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          if (!spent) {
            unspent.push(tx);
          }
        } // @ToDo: Check if some spentTransactions txids are missing from the unspentTransactions array
        // If the txid is missing from the unspentTransactions array, then remove it from the spentTransactions array
        // This clears out any spentTransactions that have been confirmed as no longer unspent.

      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return unspent;
    }
    /**
     * Add a TXID to the local Spent Transactions of the Address to prevent a specific output from being doublespent.
     * @example
     * import { Address, Networks } from '@oipwg/hdmw';
     *
     * let address = new Address("F8P6nUvDfcHikqdUnoQaGPBVxoMcUSpGDp", Networks.flo, false);
     * address.addSpentTransaction("7687e361f00998f96b29938bf5b7d9003a15ec182c13b6ddbd5adc0f993cbf9c")
     * @param {string} txid - The TXID of the spent output that we should remove
     */

  }, {
    key: "addSpentTransaction",
    value: function addSpentTransaction(txid) {
      this.spentTransactions.push(txid);
    }
  }]);

  return Address;
}();

module.exports = Address;